import React from "react"


export const IndividualSvg: React.FC<{
  height?: number;
  width?: number;
  className?: string;
}> = ({ height = 75, width = 75, className }) => {

  return (
    <>
      <img
        width={width}
        height={height}
        className={className}
        src={"/assets/images/individual.png"}
      />
    </>
  );
};
